import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

const LinkView = ({
  text, link, onClick, hardRedirect,
}) => {
  const onClickCallback = useCallback(() => onClick({ link }), [link, onClick]);

  return hardRedirect ? (
    <a href={link} className="avatarly-pri-text">{text}</a>
  ) : <span onClick={onClickCallback} className="avatarly-pri-text cursor">{text}</span>;
};

LinkView.defaultProps = {
  text: '',
  link: '',
  onClick: () => {},
  hardRedirect: false,
};

LinkView.propTypes = {
  text: PropTypes.string,
  link: PropTypes.string,
  onClick: PropTypes.func,
  hardRedirect: PropTypes.bool,
};

export default memo(LinkView);
